export default __webpack_public_path__ + "static/cert-4-img-9d832b0978976bf03ad962e502beefc1.png";